import AccountTreeIcon from '@mui/icons-material/AccountTree'
import PresetList from './PresetList'
import PresetEdit from './PresetEdit'
import PresetCreate from './PresetCreate'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: PresetList,
    edit: PresetEdit,
    create: PresetCreate,
    icon: AccountTreeIcon
}
